module.exports = __webpack_public_path__ + "img/art13.10ac1407.png";